export default __webpack_public_path__ + "locales/sl/PeopleTranslations.json?hash=398c5e1fd54159764ab9cc4eb6bd5b3e";